// Bridge between Apollo's errorLink (outside React) and AuthContext (inside React).
// errorLink calls notifyTokenRefresh after a silent refresh; AuthContext registers a handler.

let onTokenRefresh = null;

export const setTokenRefreshHandler = (handler) => {
  onTokenRefresh = handler;
};

export const notifyTokenRefresh = (tokens) => {
  if (onTokenRefresh) onTokenRefresh(tokens);
};
